module.exports = __webpack_public_path__ + "static/media/location-icon-atlas-2.42603b0d.png";